//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'CandidatesPortalModal',
  props: {
    jobId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      email: '',
      code: ''
    }
  },
  methods: {
    async sendCode () {
      if (this.code) {
        const result = await this.$axios.post('/api/jobs/login', {
          code: this.code, email: this.email
        }).catch((resp) => {
          console.log(resp.data)
        })
        if (result.data.message === 'success') {
          this.$nuxt.$emit('successLogin', result.data)
          window.localStorage.setItem('jobsCode', this.code)
          this.$modal.hide('candidates-portal-modal')
        }
        if (result.data.message === 'error') {
          this.$toast.error(this.$t('incorrect-password-or-account-not-found'))
        }
      }
    }
  }
}
